package domain.usecase

import domain.repository.ThemeRepository
import ui.theme.ThemeMode
import kotlinx.coroutines.flow.Flow

/**
 * Use case for theme management
 */
class ObserveThemeUseCase(
    private val themeRepository: ThemeRepository
) {
    
    /**
     * Observe theme changes reactively
     */
    fun execute(): Flow<ThemeMode> {
        return themeRepository.observeTheme()
    }
}

class ChangeThemeUseCase(
    private val themeRepository: ThemeRepository
) {
    
    /**
     * Change theme
     */
    suspend fun execute(theme: ThemeMode) {
        themeRepository.setTheme(theme)
    }
}
